export function secureFileLink(url: string, guestId?: string) {
  const token = '*|GUEST:guest_id|*'
  return `${url}?guest_id=${guestId || token}`
}
